<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form  :inline="true" :model="searchForm" ref="searchForm" label-width="80px" size="mini">
          <el-form-item label="区域" prop="organizationName">
            <el-input class="form-input"  v-model="searchForm.organizationName" clearable></el-input>
          </el-form-item>
          <el-form-item label="经销商" prop="customerName">
            <el-input class="form-input" v-model="searchForm.customerName" clearable></el-input>
          </el-form-item>
          <el-form-item label="是否参与" prop="boolJoin">
            <el-select v-model="searchForm.boolJoin" clearable @change="onSearch">
              <el-option v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否隐藏" prop="boolHidden">
            <el-select v-model="searchForm.boolHidden" clearable @change="onSearch">
              <el-option v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="save">保存</el-button>
      </template>
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        :data="tableData"
        row-key="nodeId"
        border
        highlight-current-row
        :height="maxTableHeight"
        :tree-props="{children: 'childrens'}">
        <el-table-column show-overflow-tooltip prop="nodeName" label="名称"></el-table-column>
        <el-table-column align="center" prop="address" label="是否参与">
          <template slot-scope="scope">
            <el-checkbox 
              :disabled="scope.row.joinForbidden"
              :indeterminate="scope.row.isJoinHalfCheck" 
              v-model="scope.row.isJoinCheck" 
              @change="handleCheckAllChange(scope.row,'Join')"
            >
            </el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否隐藏">
          <template  slot-scope="scope">
            <el-checkbox 
              :indeterminate="scope.row.isHideHalfCheck" 
              v-model="scope.row.isHideCheck"
              @change="handleCheckAllChange(scope.row,'Hide')"
            >
            </el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </table-panel>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      isFirstInto: false,
      searchForm: {
        activityId: '',
        organizationName: '',
        customerName: '',
        boolJoin: '',
        boolHidden:'',
      },
      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      statusOptions: [
        {value: '', label: '全部'},
        {value: 0, label: '否'},
        {value: 1, label: '是'},
      ],
    }
  },
  methods: {
    init() {
      this.getList();
    },
    handleCheckAllChange(val,field) {
      let isHalfCheck = `is${field}HalfCheck`
      let isCheck = `is${field}Check`
      let boolCheck = field == 'Join' ? 'boolJoin' : 'boolHidden'
      // 全选或全取消
      if (val.childrens){
        val[isHalfCheck] = false
        val.childrens.forEach(item => {
          // 已经参与的不能修改
          if (field != 'Join' || !item.joinForbidden) {
            item[isCheck] = val[isCheck] ? true : false
            item[boolCheck] = val[isCheck] ? 1: 0
          }
        })
      }else {
        val[boolCheck] = val[isCheck] ? 1 : 0
        let parent = this.lookupParent(val.organizationCode)
        if (JSON.stringify(parent) != '{}'){
          let showHalfCheck = parent.childrens.some(item => item[isCheck] == true)
          let isAll = parent.childrens.every(item => item[isCheck] == true)
          parent[isCheck] = isAll
          if (!isAll) {
            parent[isHalfCheck] = showHalfCheck
          }else {
            parent[isHalfCheck] = false
          }
        }
      }
    },
    lookupParent(organizationCode) {
      let parent = {}
      for (let i=0 ; i < this.tableData.length; i++) {
        if (organizationCode === this.tableData[i].nodeId){
          parent = this.tableData[i]
          break
        }
      }
      return parent
    },
    save() {
      let parames = {
        activityId: this.$route.query.activityId,
        organizations: this.tableData
      }
      this.loading = true;
      this.$api.ActivityManagement.saveJoinAndHidden(parames)
        .then(res => {
          if (res.success) {
            this.$notify.success({
              title: '成功',
              message: '保存成功'
            })
            this.getList();
          }
        })
        .finally(_=>{
          this.loading = false
        })
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
          activityId:this.$route.query.activityId
        }
      }
      this.$api.ActivityManagement.queryOrganizationList(params)
        .then(({data: {list, total}}) => {
          list.forEach(item => {
            item.isAll = false
          });
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === 'updatedTime' && val) {
          this.filterParam.endTimeStart = val[0] || '';
          this.filterParam.endTimeEnd = val[1] || '';
        } else if (typeof val !== 'undefined' && val !== null && val !== '') {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
  },
  created() {
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
.date-input
  width 220px !important
.content 
  width 100%
  height 100%
  display flex
  justify-content center
  align-items center
  flex-direction column
  .or-code 
    width 140px
    height 140px
    margin-top 20px
</style>